import React from "react";

import { withFormik } from "formik";
import { compose } from "recompose";

import * as yup from "yup";
import { useFormattedMessage } from "hooks";

import InputFancy from "components/InputFancy";

import { validationObject } from "utils/yupValidation";
import { email, password } from "i18n/messages/formElements";
import { forgetPasswordAPI } from "api";
import NewLoader from "./NewLoader";

const messages = {
    ...email,
    emailNotFound: "account_not_found",
    accountBlock: "account_is_blocked",
    somethingWentWrong: "oops_something_went_wrong",
};

const ForgotPasswordForm = ({
    values,
    errors,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    setFieldTouched,
}) => {
    const { formatMessage } = useFormattedMessage();

    return (
        <form method="post" onSubmit={handleSubmit}>
            <InputFancy
                type="text"
                name="email"
                placeholder={formatMessage(email.emailPlaceholder)}
                onChange={(e) => {
                    handleChange(e);
                    setFieldTouched("email", true);
                }}
                value={values.email}
                onBlur={handleBlur}
                errorMessage={errors.email ? formatMessage(messages[errors.email]) : null}
                error={touched.email && errors.email}
            />
            <button type="submit" disabled={isSubmitting} className={`${isSubmitting ? "disable-grey" : ""}`}>
                {isSubmitting && <NewLoader />}
                {formatMessage(password.resetPassword)}
            </button>
        </form>
    );
};

export default compose(
    withFormik({
        mapPropsToValues: () => ({ email: "" }),
        validateOnBlur: true,
        validateOnChange: true,
        validationSchema: () =>
            yup.object().shape({
                email: validationObject.email,
            }),
        handleSubmit: async (values, { setSubmitting, setStatus, resetForm, props, setFieldError }) => {
            try {
                const res = await forgetPasswordAPI(values.email.trim());

                if (res?.data?.errors?.length) {
                    const error = res.data.errors[0].message;
                    setStatus({ success: false });

                    let errorMessage = "";

                    if (error === "email_not_found") {
                        errorMessage = "emailNotFound";
                    } else if (error === "account_is_blocked") {
                        errorMessage = "accountBlock";
                    } else if (error === "sending_email_failed") {
                        errorMessage = "somethingWentWrong";
                    }

                    return setFieldError("email", errorMessage);
                }

                setStatus({ success: true });
                resetForm({});
                return props.formSubmitSuccess();
            } catch (error) {
                setStatus({ success: false });
                setSubmitting(false);
                setFieldError("email", "somethingWentWrong");
            }
        },
        displayName: "ForgotPasswordForm",
    })
)(ForgotPasswordForm);
